<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="closeNotice()">close</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{$t('602')}}
                                <!-- 공지사항 -->
                            </div>                
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                    
                </header>
                <section class="flex-grow-1 scroll-y">
                    <div class="pda-default">
                        <div class="t-body3 t-color-content1 notice-contents" v-html="noticeData.contents"></div>
                    </div>
                </section>
                <section>
                    <div class="pda-default">
                        <button class="mdc-button mdc-button--raised btn-red" @click="closeNotice">
                            {{$t('603')}}
                        </button>
                    </div>
                </section>
                
            </div>
        </div>
    </div>
</template>

<script>

/**
 * 차수 상세 공지사항 팝업 컴포넌트(degree view Notice popup component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    props: ['noticeData'],
    methods: {
        // 공지사항 닫기(close Notice)
        closeNotice() {
            this.$emit('closeNotice')
        }
    }
}
</script>